import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel2';
import axios from 'axios';

const Brand = (props) =>  {
    const { brandBg, brandClass } = props;

    const [brands, setBrands] = useState([]);

    useEffect(() => {
        // Fetch the brand data from the API
        axios.get('https://yautiktechnology.com/api/brand/all')
            .then(response => {
                setBrands(response.data);
            })
            .catch(error => {
                console.error("Error fetching brand data:", error);
            });
    }, []);

    const brandBgStyle = {
        backgroundImage: `url(${brandBg ? brandBg : ''})`
    };

    const brandBgDefaultStyle = {
        backgroundColor: '#00005B'
    };

    const options = {
        items: 5,
        nav: false,
        dots: false,
        rewind: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        stagePadding: 30,
        margin: 30,
        loop: true,
        center: false,
        responsive: {
            0: {
                items: 1,
            },
            480: {
                items: 2,
                stagePadding: 0,
            },
            768: {
                items: 3,
            },
            992: {
                items: 3,
            },
            1200: {
                items: 4,
            },
            1500: {
                items: 5,
            }
        }
    };

    return (
        <div className={brandClass ? brandClass : 'rs-partner pt-80 pb-70'} style={brandBg ? brandBgStyle : brandBgDefaultStyle}>
            <div className="container">
                <OwlCarousel options={options}>
                    {brands.map(brand => (
                        <div key={brand.id} className="partner-item">
                            <div className="logo-img">
                                <a href="#">
                                    <img className="hover-logo" src={brand.bwImg} alt={`Brand ${brand.id} hover`} />
                                    <img className="main-logo" src={brand.clrImg} alt={`Brand ${brand.id} main`} />
                                </a>
                            </div>
                        </div>
                    ))}
                </OwlCarousel>
            </div>
        </div>
    );
};

export default Brand;
